import { Box, Typography } from '@mui/material';
import theme from '../../Theme';

interface CardListFooterProps {
  totalCount: number;
  loadedCount: number;
  id?: string;
}

const CardListFooter: React.FC<CardListFooterProps> = (props: CardListFooterProps) => {
  const { totalCount, loadedCount, id } = props;
  
  return (
    <Box id={id} sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-end', 
      width: '100%', 
      height: '48px',
      borderTop: `solid 1px ${theme.palette.border.main}`
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mr: '56px' }}>
        <Typography variant="body2" color="text.primary" sx={{ mr: 1 }}>
          Total Count:
        </Typography>
        <Typography variant="body2" color="text.primary">
          {loadedCount === totalCount 
            ? totalCount.toString() 
            : `${loadedCount} of ${totalCount}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CardListFooter;
